/**
 * The post-session feedback SCALES — the word a client read for each score.
 *
 * `FeedbackIn.rating` and `FeedbackIn.understood` persist a bare INTEGER. Nothing
 * else in the system records what a 4 was, so these words are the whole definition
 * of the stored value, exactly as an option key's label is. They are locked in
 * `me/labelLock.ts` for that reason: rewording a score in place would silently
 * restate what everyone who picked it is recorded as having meant.
 *
 * `as const` is load-bearing — it keeps the literal types the lock compares.
 * `FeedbackFlow` additionally branches on the NUMBERS (`understood <= 2`,
 * `rating >= 4`), so a score here carries behaviour as well as meaning.
 */

export const RATING_WORDS = {
  1: "Rough",
  2: "Hard going",
  // Reworded 2026-09-17 from "A mixed bag"; ratings of 3 saved before then were given under that word.
  3: "Okay",
  4: "Good",
  5: "Really helpful",
} as const;

export const UNDERSTOOD_WORDS = {
  1: "Not really",
  2: "A little",
  3: "Somewhat",
  4: "Mostly seen",
  5: "Completely seen",
} as const;
